<template>
    <section class="modal-ver-imagen">
        <modal ref="ver_archivo" titulo="" tamano="modal-xl">
            <div class="row mx-0 my-3 justify-center" oncontextmenu="return false" onkeydown="return false">
                <img :src="ruta" alt="" class="imagen m-auto" />
            </div>
        </modal>
    </section>
</template>

<script>
export default {
    data(){
        return {
            ruta:''
        }
    },
    methods: {
        toggle(ruta){
            this.ruta=ruta
            this.$refs.ver_archivo.toggle()
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-ver-imagen{
    .imagen{
        max-height: calc(100vh - 160px);;
        max-width: 100%;
        object-fit: cover;
    }

}
</style>
